import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { MteService } from './mte.service';
import { ApiService, ErrorTypeWithTime } from '../api/api.service';
import { VerifyForm } from '../Services/session.service';
import { ApiAboutService } from './api-about.service';

interface ApiRegistrationResponse {
  voting_pin?: string;
  pin_sent?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
  registered: boolean = false
  constructor(
    private readonly http: HttpClient, 
    private mte: MteService, 
    private apiService: ApiService,
    private readonly aboutService: ApiAboutService
  ) { }

  /**
   *
   * Register the user for the election and release the user's voting PIN
   *
   * If successful, and a pinFieldName is a part of the verification form, a string voting PIN will be returned. 
   * This string can be provided as the VoterId in a subsequent Create Session
   * request for the same user.
   *
   * If unsuccessful, an error will be thrown. The error object may have
   * an 'error_type' field. If the information is incorrect, the
   * error_type may be 'INVALID_IDENTITY', 'ALREADY_REGISTERED', or 'INTERNAL_SERVERERROR'.
   *
   * @param form the verification form from the users registration
   * @return string or undefined; the voting PIN if the pinFieldName is set on the form.
   */
  register(form: VerifyForm, recaptchaResponse: string): Observable<string | boolean> {
    let response: Observable<HttpResponse<ApiRegistrationResponse>>;
    let requestBody: any = {
      data: form.keyPairs,
      pinFieldName: form.pinFieldName,
      locale: form.locale
    };
    if(!this.aboutService.isVotingCenter()) {
      requestBody["g-recaptcha-response"] = recaptchaResponse;
    }
    if (this.mte.useMte) {
      response = this.apiService.postWithHandshakeCheck<ApiRegistrationResponse>('/api/registration', requestBody);
    }
    else {
      response = this.http.post<ApiRegistrationResponse>('/api/registration', requestBody, {
        observe: 'response' as 'response',
        responseType: 'json',
      });
    }

    return response.pipe(
      map(r => {
        if (r.body) {
          if (r.body.voting_pin) {
            return r.body.voting_pin
          }
          else if (r.body.pin_sent) {
            return true
          }
        }
        return false
      }),
      catchError(e => {
        this.mte.needHandshake = true;
        throw e.error as ErrorTypeWithTime;
      })
    );
  }
}
